namespace Matrix.Data {
    export interface AccountModelTargetIsPendingApprovalResponse extends Serenity.ServiceResponse {
        PendingOperation?: string;
        WorkflowInstanceId?: number;
        Targets?: AccountModelTargetRow[];
        CanApprove?: boolean;
        CanReject?: boolean;
    }
}
